import {BotType} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allBotTypeOptions: SelectOption<BotType>[] = [
    {
        value: BotType.AimeStarter,
        label: "Aime Starter"
    },
    {
        value: BotType.AimeStock,
        label: "Aime Stock"
    },
    {
        value: BotType.AimePx,
        label: "Aime Px"
    },
    {
        value: BotType.AimeFinance,
        label: "Aime Finance"
    },
    {
        value: BotType.AimeReservation,
        label: "Aime Reservation"
    },
    {
        value: BotType.AimeBuy,
        label: "Aime Buy"
    },
    {
        value: BotType.TmcAime,
        label: "TMC Aime"
    }
]

export const getBotTypeName = (botType: BotType) => {
    const option = allBotTypeOptions.filter(o => o.value === botType)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle botType: ${botType} correctly`)
}
